import { render, staticRenderFns } from "./newsletters.vue?vue&type=template&id=1b272e56&scoped=true"
import script from "./newsletters.vue?vue&type=script&lang=js"
export * from "./newsletters.vue?vue&type=script&lang=js"
import style0 from "./newsletters.vue?vue&type=style&index=0&id=1b272e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b272e56",
  null
  
)

export default component.exports